import { schema } from 'normalizr'
import {
  IFilterProfileLite,
  IContinuousRoute,
  IOperator,
  IRegion,
  IState
} from '$/types'
import { operatorSchema } from './operatorSchema'
import { stateSchema } from './stateSchema'
import { regionSchema } from './regionSchema'
import { lineSchema } from './lineSchema'

export interface IFilterProfileNormalizedEntities {
  filterProfiles: { [key: string]: IFilterProfileLite }
  operators: { [key: string]: IOperator }
  states: { [key: string]: IState }
  regions: { [key: string]: IRegion }
  continuousRoutes: { [key: string]: IContinuousRoute }
}

export const filterProfileSchema = new schema.Entity('filterProfiles', {
  operators: [operatorSchema],
  states: [stateSchema],
  regions: [regionSchema],
  continuousRoutes: [lineSchema]
})
